export const data = [
  //1
  {
    key: "c1-01",
    title: "우편배달부 라오와 모치",
    grade: "1권",
    cover: require("@data/assets/red/book1/images/cover.jpg"),
    background: require("@data/assets/red/book1/pages/page05.jpg"),
    song: {
      url: require("@data/assets/red/book1/sounds/page23.mp3"),
      title: "라오와 모치는 우편배달부",
      caption: [
        "라오와 모치는 우편배달부 비행기 타고 하늘을 날아요",
        "ā á   ǎ à   ā á   ǎ à",
        "높고 길게 똑바로 쭉 1성은 ā 1성은 ā",
        "낮은 곳에서 높은 곳으로 쭉 올리며 2성은 á 2성은 á",
        "내려 갔다 다시 올라가 3성은 ǎ 3성은 ǎ",
        "높은 곳에서 아래로 쭉 내려요 4성은 à 4성은 à",
        "라오와 모치는 우편배달부 비행기 타고 하늘을 날아요",
        "ā á   ǎ à   ā á   ǎ à",
      ],
    },
    mov: {
      cn: "a4bbe7fc456c7906c34471965e5deb92_01",
      en: "4f97c8f63476b6629c33f7bce78352a3_01",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/red/book1/images/img_R1-01.png"),
          sound: require("@data/assets/red/book1/sounds/KA01_W_01_제1성.mp3"),
          word: "ā",
        },
        {
          img: require("@data/assets/red/book1/images/img_R1-02.png"),
          sound: require("@data/assets/red/book1/sounds/KA01_W_02_제2성.mp3"),
          word: "á",
        },
        {
          img: require("@data/assets/red/book1/images/img_R1-03.png"),
          sound: require("@data/assets/red/book1/sounds/KA01_W_03_제3성.mp3"),
          word: "ǎ",
        },
        {
          img: require("@data/assets/red/book1/images/img_R1-04.png"),
          sound: require("@data/assets/red/book1/sounds/KA01_W_04_제4성.mp3"),
          word: "à",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/red/book1/images/img_R1-01.png"),
        sound: require("@data/assets/red/book1/sounds/KA01_W_01_제1성.mp3"),
        buttons: [{ ch2: "ā" }, { ko: "제1성" }],
      },
      {
        img: require("@data/assets/red/book1/images/img_R1-02.png"),
        sound: require("@data/assets/red/book1/sounds/KA01_W_02_제2성.mp3"),
        buttons: [{ ch2: "á" }, { ko: "제2성" }],
      },
      {
        img: require("@data/assets/red/book1/images/img_R1-03.png"),
        sound: require("@data/assets/red/book1/sounds/KA01_W_03_제3성.mp3"),
        buttons: [{ ch2: "ǎ" }, { ko: "제3성" }],
      },
      {
        img: require("@data/assets/red/book1/images/img_R1-04.png"),
        sound: require("@data/assets/red/book1/sounds/KA01_W_04_제4성.mp3"),
        buttons: [{ ch2: "à" }, { ko: "제4성" }],
      },
    ],
    idiom: [],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/red/book1/sounds/KA01_W_01_제1성.mp3"),
          img: require("@data/assets/red/book1/images/img_R1-01.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/red/book1/sounds/KA01_W_02_제2성.mp3"),
          answer: [
            [require("@data/assets/red/book1/images/img_R1-02.png"), true],
            [require("@data/assets/red/book1/images/img_R1-04.png"), false],
          ],
        },
        {
          type: "ty2",
          sound: require("@data/assets/red/book1/sounds/KA01_W_04_제4성.mp3"),
          answer: [
            [require("@data/assets/red/book1/images/img_R1-04.png"), true],
            [require("@data/assets/red/book1/images/img_R1-01.png"), false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/red/book1/pages/front.jpg"),
        sound: require("@data/assets/red/book1/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/red/book1/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/red/book1/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/red/book1/pages/page04.jpg"),
        sound: require("@data/assets/red/book1/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/red/book1/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/red/book1/pages/page06.jpg"),
        sound: require("@data/assets/red/book1/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/red/book1/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/red/book1/pages/page08.jpg"),
        sound: require("@data/assets/red/book1/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/red/book1/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/red/book1/pages/page10.jpg"),
        sound: require("@data/assets/red/book1/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/red/book1/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/red/book1/pages/page12.jpg"),
        sound: require("@data/assets/red/book1/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/red/book1/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/red/book1/pages/page14.jpg"),
        sound: require("@data/assets/red/book1/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/red/book1/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/red/book1/pages/page16.jpg"),
        sound: require("@data/assets/red/book1/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/red/book1/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/red/book1/pages/page18.jpg"),
        sound: require("@data/assets/red/book1/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/red/book1/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/red/book1/pages/page20.jpg"),
        sound: require("@data/assets/red/book1/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/red/book1/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/red/book1/pages/page22.jpg"),
        sound: require("@data/assets/red/book1/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/red/book1/pages/page23.jpg"),
        sound: require("@data/assets/red/book1/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/red/book1/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/red/book1/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/red/book1/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/red/book1/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/red/book1/thumbnail/front.jpg"),
      require("@data/assets/red/book1/thumbnail/page02.jpg"),
      require("@data/assets/red/book1/thumbnail/page03.jpg"),
      require("@data/assets/red/book1/thumbnail/page04.jpg"),
      require("@data/assets/red/book1/thumbnail/page05.jpg"),
      require("@data/assets/red/book1/thumbnail/page06.jpg"),
      require("@data/assets/red/book1/thumbnail/page07.jpg"),
      require("@data/assets/red/book1/thumbnail/page08.jpg"),
      require("@data/assets/red/book1/thumbnail/page09.jpg"),
      require("@data/assets/red/book1/thumbnail/page10.jpg"),
      require("@data/assets/red/book1/thumbnail/page11.jpg"),
      require("@data/assets/red/book1/thumbnail/page12.jpg"),
      require("@data/assets/red/book1/thumbnail/page13.jpg"),
      require("@data/assets/red/book1/thumbnail/page14.jpg"),
      require("@data/assets/red/book1/thumbnail/page15.jpg"),
      require("@data/assets/red/book1/thumbnail/page16.jpg"),
      require("@data/assets/red/book1/thumbnail/page17.jpg"),
      require("@data/assets/red/book1/thumbnail/page18.jpg"),
      require("@data/assets/red/book1/thumbnail/page19.jpg"),
      require("@data/assets/red/book1/thumbnail/page20.jpg"),
      require("@data/assets/red/book1/thumbnail/page21.jpg"),
      require("@data/assets/red/book1/thumbnail/page22.jpg"),
      require("@data/assets/red/book1/thumbnail/page23.jpg"),
      require("@data/assets/red/book1/thumbnail/page24.jpg"),
      require("@data/assets/red/book1/thumbnail/page25.jpg"),
      require("@data/assets/red/book1/thumbnail/page26.jpg"),
      require("@data/assets/red/book1/thumbnail/page27.jpg"),
    ],
  },
  //2
  {
    key: "c1-02",
    title: "요술봉아 도와줘!",
    grade: "2권",
    cover: require("@data/assets/red/book2/images/cover.jpg"),
    background: require("@data/assets/red/book2/pages/page05.jpg"),
    song: {
      url: require("@data/assets/red/book2/sounds/page23.mp3"),
      title: "요술봉아 친구들을 불러줘",
      caption: [
        "요술봉아 친구들을 불러줘 a o e i u ü",
        "요술봉 뿅뿅 나와라 말 a a a mǎ",
        "요술봉 뿅뿅 나와라 공룡 o o o kǒnglóng",
        "요술봉 뿅뿅 나와라 학 e e e hè",
        "요술봉아 친구들을 불러줘 a o e i u ü",
        "요술봉 뿅뿅 나와라 개구리 i i i qīngwā",
        "요술봉 뿅뿅 나와라 사슴 u u u lù",
        "요술봉 뿅뿅 나와라 당나귀 ü ü ü <span style='font-family:sans-serif;'>lǘ</span>",
        "요술봉아 친구들을 불러줘 a o e i u ü",
        "요술봉아 친구들을 불러줘 a o e i u ü",
      ],
    },
    mov: {
      cn: "ce5deb856c313957f2fe38e953224ae2_02",
      en: "995a18126aad033788ffc7869b32dd34_02",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/red/book2/images/img_R2-01.png"),
          sound: require("@data/assets/red/book2/sounds/KA02_W_01_말.mp3"),
          word: "马|mǎ",
        },
        {
          img: require("@data/assets/red/book2/images/img_R2-02.png"),
          sound: require("@data/assets/red/book2/sounds/KA02_W_02_공룡.mp3"),
          word: "恐龙|kǒnglóng",
        },
        {
          img: require("@data/assets/red/book2/images/img_R2-03.png"),
          sound: require("@data/assets/red/book2/sounds/KA02_W_03_학.mp3"),
          word: "鹤|hè",
        },
        {
          img: require("@data/assets/red/book2/images/img_R2-04.png"),
          sound: require("@data/assets/red/book2/sounds/KA02_W_04_개구리.mp3"),
          word: "青蛙|qīngwā",
        },
        {
          img: require("@data/assets/red/book2/images/img_R2-05.png"),
          sound: require("@data/assets/red/book2/sounds/KA02_W_05_사슴.mp3"),
          word: "鹿|lù",
        },
        {
          img: require("@data/assets/red/book2/images/img_R2-06.png"),
          sound: require("@data/assets/red/book2/sounds/KA02_W_06_당나귀.mp3"),
          word: "驴|<span style='font-family:sans-serif;'>lǘ</span>",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/red/book2/images/img_R2-01.png"),
        sound: require("@data/assets/red/book2/sounds/KA02_W_01_말.mp3"),
        buttons: [{ ch2: "mǎ" }, { ch: "马" }, { ko: "말" }],
      },
      {
        img: require("@data/assets/red/book2/images/img_R2-02.png"),
        sound: require("@data/assets/red/book2/sounds/KA02_W_02_공룡.mp3"),
        buttons: [{ ch2: "kǒnglóng" }, { ch: "恐龙" }, { ko: "공룡" }],
      },
      {
        img: require("@data/assets/red/book2/images/img_R2-03.png"),
        sound: require("@data/assets/red/book2/sounds/KA02_W_03_학.mp3"),
        buttons: [{ ch2: "hè" }, { ch: "鹤" }, { ko: "학" }],
      },
      {
        img: require("@data/assets/red/book2/images/img_R2-04.png"),
        sound: require("@data/assets/red/book2/sounds/KA02_W_04_개구리.mp3"),
        buttons: [{ ch2: "qīngwā" }, { ch: "青蛙" }, { ko: "개구리" }],
      },
      {
        img: require("@data/assets/red/book2/images/img_R2-05.png"),
        sound: require("@data/assets/red/book2/sounds/KA02_W_05_사슴.mp3"),
        buttons: [{ ch2: "lù" }, { ch: "鹿" }, { ko: "사슴" }],
      },
      {
        img: require("@data/assets/red/book2/images/img_R2-06.png"),
        sound: require("@data/assets/red/book2/sounds/KA02_W_06_당나귀.mp3"),
        buttons: [
          { ch2: "<span style='font-family:sans-serif;'>lǘ</span>" },
          { ch: "驴" },
          { ko: "당나귀" },
        ],
      },
    ],

    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/red/book2/sounds/KA02_W_01_말.mp3"),
          img: require("@data/assets/red/book2/images/img_R2-02.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/red/book2/sounds/KA02_W_04_개구리.mp3"),
          answer: [
            [require("@data/assets/red/book2/images/img_R2-03.png"), false],
            [require("@data/assets/red/book2/images/img_R2-04.png"), true],
          ],
        },
        {
          type: "ty2",
          sound: require("@data/assets/red/book2/sounds/KA02_W_05_사슴.mp3"),
          answer: [
            [require("@data/assets/red/book2/images/img_R2-06.png"), false],
            [require("@data/assets/red/book2/images/img_R2-05.png"), true],
          ],
        },
      ],
    },

    pages: [
      {
        book: require("@data/assets/red/book2/pages/front.jpg"),
        sound: require("@data/assets/red/book2/sounds/cover.mp3"),
      },
      {
        book: require("@data/assets/red/book2/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/red/book2/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/red/book2/pages/page04.jpg"),
        sound: require("@data/assets/red/book2/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/red/book2/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/red/book2/pages/page06.jpg"),
        sound: require("@data/assets/red/book2/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/red/book2/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/red/book2/pages/page08.jpg"),
        sound: require("@data/assets/red/book2/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/red/book2/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/red/book2/pages/page10.jpg"),
        sound: require("@data/assets/red/book2/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/red/book2/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/red/book2/pages/page12.jpg"),
        sound: require("@data/assets/red/book2/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/red/book2/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/red/book2/pages/page14.jpg"),
        sound: require("@data/assets/red/book2/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/red/book2/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/red/book2/pages/page16.jpg"),
        sound: require("@data/assets/red/book2/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/red/book2/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/red/book2/pages/page18.jpg"),
        sound: require("@data/assets/red/book2/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/red/book2/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/red/book2/pages/page20.jpg"),
        sound: require("@data/assets/red/book2/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/red/book2/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/red/book2/pages/page22.jpg"),
        sound: require("@data/assets/red/book2/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/red/book2/pages/page23.jpg"),
        sound: require("@data/assets/red/book2/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/red/book2/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/red/book2/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/red/book2/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/red/book2/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/red/book2/thumbnail/front.jpg"),
      require("@data/assets/red/book2/thumbnail/page02.jpg"),
      require("@data/assets/red/book2/thumbnail/page03.jpg"),
      require("@data/assets/red/book2/thumbnail/page04.jpg"),
      require("@data/assets/red/book2/thumbnail/page05.jpg"),
      require("@data/assets/red/book2/thumbnail/page06.jpg"),
      require("@data/assets/red/book2/thumbnail/page07.jpg"),
      require("@data/assets/red/book2/thumbnail/page08.jpg"),
      require("@data/assets/red/book2/thumbnail/page09.jpg"),
      require("@data/assets/red/book2/thumbnail/page10.jpg"),
      require("@data/assets/red/book2/thumbnail/page11.jpg"),
      require("@data/assets/red/book2/thumbnail/page12.jpg"),
      require("@data/assets/red/book2/thumbnail/page13.jpg"),
      require("@data/assets/red/book2/thumbnail/page14.jpg"),
      require("@data/assets/red/book2/thumbnail/page15.jpg"),
      require("@data/assets/red/book2/thumbnail/page16.jpg"),
      require("@data/assets/red/book2/thumbnail/page17.jpg"),
      require("@data/assets/red/book2/thumbnail/page18.jpg"),
      require("@data/assets/red/book2/thumbnail/page19.jpg"),
      require("@data/assets/red/book2/thumbnail/page20.jpg"),
      require("@data/assets/red/book2/thumbnail/page21.jpg"),
      require("@data/assets/red/book2/thumbnail/page22.jpg"),
      require("@data/assets/red/book2/thumbnail/page23.jpg"),
      require("@data/assets/red/book2/thumbnail/page24.jpg"),
      require("@data/assets/red/book2/thumbnail/page25.jpg"),
      require("@data/assets/red/book2/thumbnail/page26.jpg"),
      require("@data/assets/red/book2/thumbnail/page27.jpg"),
    ],
  },
  //3
  {
    key: "c1-03",
    title: "한눈팔면 안돼요",
    grade: "3권",
    cover: require("@data/assets/red/book3/images/cover.jpg"),
    background: require("@data/assets/red/book3/pages/page05.jpg"),
    song: {
      url: require("@data/assets/red/book3/sounds/page23.mp3"),
      title: "할아버지께 무얼 사드릴까",
      caption: [
        "할아버지께 무얼 사드릴까",
        "맛있는걸 살거야 mǎi mǎi mǎi mǎi mǎi mǎi",
        "새콤한 파인애플 나는 파인애플을 사요",
        "bōluó  bōluó wǒ mǎi bōluó",
        "탐스런 사과 나는 사과를 사요",
        "píngguǒ píngguǒ wǒ mǎi píngguǒ",
        "갓구운빵 나는 빵을 사요",
        "miànbāo miànbāo wǒ mǎi miànbāo",
        "달콤한 꿀 나는 꿀을 사요",
        "fēngmì fēngmì wǒ mǎi fēngmì",
      ],
    },
    mov: {
      cn: "5bd6354b57ff874479e29affd6b582bc_03",
      en: "f8f4f383066dcb44a245753e2bf65b54_03",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/red/book3/images/img_R3-01.png"),
          sound: require("@data/assets/red/book3/sounds/KA03_W_01_파인애플.mp3"),
          word: "菠萝|bōluó",
        },
        {
          img: require("@data/assets/red/book3/images/img_R3-02.png"),
          sound: require("@data/assets/red/book3/sounds/KA03_W_02_사과.mp3"),
          word: "苹果|píngguǒ",
        },
        {
          img: require("@data/assets/red/book3/images/img_R3-03.png"),
          sound: require("@data/assets/red/book3/sounds/KA03_W_03_빵.mp3"),
          word: "面包|miànbāo",
        },
        {
          img: require("@data/assets/red/book3/images/img_R3-04.png"),
          sound: require("@data/assets/red/book3/sounds/KA03_W_04_벌꿀.mp3"),
          word: "蜂蜜|fēngmì",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/red/book3/images/img_R3-01.png"),
        sound: require("@data/assets/red/book3/sounds/KA03_W_01_파인애플.mp3"),
        buttons: [{ ch2: "bōluó" }, { ch: "菠萝" }, { ko: "파인애플" }],
      },
      {
        img: require("@data/assets/red/book3/images/img_R3-02.png"),
        sound: require("@data/assets/red/book3/sounds/KA03_W_02_사과.mp3"),
        buttons: [{ ch2: "píngguǒ" }, { ch: "苹果" }, { ko: "사과" }],
      },
      {
        img: require("@data/assets/red/book3/images/img_R3-03.png"),
        sound: require("@data/assets/red/book3/sounds/KA03_W_03_빵.mp3"),
        buttons: [{ ch2: "miànbāo" }, { ch: "面包" }, { ko: "빵" }],
      },
      {
        img: require("@data/assets/red/book3/images/img_R3-04.png"),
        sound: require("@data/assets/red/book3/sounds/KA03_W_04_벌꿀.mp3"),
        buttons: [{ ch2: "fēngmì" }, { ch: "蜂蜜" }, { ko: "벌꿀" }],
      },
    ],
    //3
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/red/book3/sounds/KA03_W_01_파인애플.mp3"),
          img: require("@data/assets/red/book3/images/img_R3-01.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/red/book3/sounds/KA03_W_02_사과.mp3"),
          answer: [
            [require("@data/assets/red/book3/images/img_R3-03.png"), false],
            [require("@data/assets/red/book3/images/img_R3-02.png"), true],
          ],
        },
        {
          type: "ty2",
          sound: require("@data/assets/red/book3/sounds/KA03_W_04_벌꿀.mp3"),
          answer: [
            [require("@data/assets/red/book3/images/img_R3-02.png"), false],
            [require("@data/assets/red/book3/images/img_R3-04.png"), true],
          ],
        },
      ],
    },

    pages: [
      {
        book: require("@data/assets/red/book3/pages/front.jpg"),
        sound: require("@data/assets/red/book3/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/red/book3/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/red/book3/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/red/book3/pages/page04.jpg"),
        sound: require("@data/assets/red/book3/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/red/book3/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/red/book3/pages/page06.jpg"),
        sound: require("@data/assets/red/book3/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/red/book3/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/red/book3/pages/page08.jpg"),
        sound: require("@data/assets/red/book3/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/red/book3/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/red/book3/pages/page10.jpg"),
        sound: require("@data/assets/red/book3/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/red/book3/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/red/book3/pages/page12.jpg"),
        sound: require("@data/assets/red/book3/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/red/book3/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/red/book3/pages/page14.jpg"),
        sound: require("@data/assets/red/book3/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/red/book3/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/red/book3/pages/page16.jpg"),
        sound: require("@data/assets/red/book3/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/red/book3/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/red/book3/pages/page18.jpg"),
        sound: require("@data/assets/red/book3/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/red/book3/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/red/book3/pages/page20.jpg"),
        sound: require("@data/assets/red/book3/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/red/book3/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/red/book3/pages/page22.jpg"),
        sound: require("@data/assets/red/book3/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/red/book3/pages/page23.jpg"),
        sound: require("@data/assets/red/book3/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/red/book3/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/red/book3/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/red/book3/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/red/book3/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/red/book3/thumbnail/front.jpg"),
      require("@data/assets/red/book3/thumbnail/page02.jpg"),
      require("@data/assets/red/book3/thumbnail/page03.jpg"),
      require("@data/assets/red/book3/thumbnail/page04.jpg"),
      require("@data/assets/red/book3/thumbnail/page05.jpg"),
      require("@data/assets/red/book3/thumbnail/page06.jpg"),
      require("@data/assets/red/book3/thumbnail/page07.jpg"),
      require("@data/assets/red/book3/thumbnail/page08.jpg"),
      require("@data/assets/red/book3/thumbnail/page09.jpg"),
      require("@data/assets/red/book3/thumbnail/page10.jpg"),
      require("@data/assets/red/book3/thumbnail/page11.jpg"),
      require("@data/assets/red/book3/thumbnail/page12.jpg"),
      require("@data/assets/red/book3/thumbnail/page13.jpg"),
      require("@data/assets/red/book3/thumbnail/page14.jpg"),
      require("@data/assets/red/book3/thumbnail/page15.jpg"),
      require("@data/assets/red/book3/thumbnail/page16.jpg"),
      require("@data/assets/red/book3/thumbnail/page17.jpg"),
      require("@data/assets/red/book3/thumbnail/page18.jpg"),
      require("@data/assets/red/book3/thumbnail/page19.jpg"),
      require("@data/assets/red/book3/thumbnail/page20.jpg"),
      require("@data/assets/red/book3/thumbnail/page21.jpg"),
      require("@data/assets/red/book3/thumbnail/page22.jpg"),
      require("@data/assets/red/book3/thumbnail/page23.jpg"),
      require("@data/assets/red/book3/thumbnail/page24.jpg"),
      require("@data/assets/red/book3/thumbnail/page25.jpg"),
      require("@data/assets/red/book3/thumbnail/page26.jpg"),
      require("@data/assets/red/book3/thumbnail/page27.jpg"),
    ],
  },
  //4
  {
    key: "c1-04",
    title: "깜짝 생일파티",
    grade: "4권",
    cover: require("@data/assets/red/book4/images/cover.jpg"),
    background: require("@data/assets/red/book4/pages/page05.jpg"),
    song: {
      url: require("@data/assets/red/book4/sounds/page23.mp3"),
      title: "신나게 춤을 춰요",
      caption: [
        "신나게 춤을 춰요 다 함께 춤을 춰요",
        "tiàowǔ tiàowǔ tiàowǔ tiàowǔ",
        "뿌우 코끼리 코끼리가 춤을 춰요",
        "dàxiàng dàxiàng dàxiàng tiàowǔ",
        "깡총 깡총 토끼 토끼가 춤을 춰요",
        "tùzi tùzi tùzi tiàowǔ",
        "신나게 춤을 춰요 다함께 춤을 춰요",
        " tiàowǔ tiàowǔ  tiàowǔ tiàowǔ",
        "음매 소 소가 춤을 춰요  niú niú niú tiàowǔ",
        "어흥 호랑이 호랑이가 춤을 춰요",
        "lǎohǔ lǎohǔ lǎohǔ tiàowǔ",
      ],
    },
    mov: {
      cn: "94ca8cbae973b627fa5b7dff07b6819b_04",
      en: "d6a7158dde5439e404b17b3791becded_04",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/red/book4/images/img_R4-01.png"),
          sound: require("@data/assets/red/book4/sounds/KA04_W_01_코끼리.mp3"),
          word: "大象|dàxiàng",
        },
        {
          img: require("@data/assets/red/book4/images/img_R4-02.png"),
          sound: require("@data/assets/red/book4/sounds/KA04_W_02_토끼.mp3"),
          word: "兔子|tùzi",
        },
        {
          img: require("@data/assets/red/book4/images/img_R4-03.png"),
          sound: require("@data/assets/red/book4/sounds/KA04_W_03_소.mp3"),
          word: "牛|niú",
        },
        {
          img: require("@data/assets/red/book4/images/img_R4-04.png"),
          sound: require("@data/assets/red/book4/sounds/KA04_W_04_호랑이.mp3"),
          word: "老虎|lǎohǔ",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/red/book4/images/img_R4-01.png"),
        sound: require("@data/assets/red/book4/sounds/KA04_W_01_코끼리.mp3"),
        buttons: [{ ch2: "dàxiàng" }, { ch: "大象" }, { ko: "코끼리" }],
      },
      {
        img: require("@data/assets/red/book4/images/img_R4-02.png"),
        sound: require("@data/assets/red/book4/sounds/KA04_W_02_토끼.mp3"),
        buttons: [{ ch2: "tùzi" }, { ch: "兔子" }, { ko: "토끼" }],
      },
      {
        img: require("@data/assets/red/book4/images/img_R4-03.png"),
        sound: require("@data/assets/red/book4/sounds/KA04_W_03_소.mp3"),
        buttons: [{ ch2: "niú" }, { ch: "牛" }, { ko: "소" }],
      },
      {
        img: require("@data/assets/red/book4/images/img_R4-04.png"),
        sound: require("@data/assets/red/book4/sounds/KA04_W_04_호랑이.mp3"),
        buttons: [{ ch2: "lǎohǔ" }, { ch: "老虎" }, { ko: "호랑이" }],
      },
    ],
    //4
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/red/book4/sounds/KA04_W_01_코끼리.mp3"),
          img: require("@data/assets/red/book4/images/img_R4-02.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/red/book4/sounds/KA04_W_03_소.mp3"),
          answer: [
            [require("@data/assets/red/book4/images/img_R4-02.png"), false],
            [require("@data/assets/red/book4/images/img_R4-03.png"), true],
          ],
        },
        {
          type: "ty2",
          sound: require("@data/assets/red/book4/sounds/KA04_W_04_호랑이.mp3"),
          answer: [
            [require("@data/assets/red/book4/images/img_R4-04.png"), true],
            [require("@data/assets/red/book4/images/img_R4-01.png"), false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/red/book4/pages/front.jpg"),
        sound: require("@data/assets/red/book4/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/red/book4/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/red/book4/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/red/book4/pages/page04.jpg"),
        sound: require("@data/assets/red/book4/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/red/book4/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/red/book4/pages/page06.jpg"),
        sound: require("@data/assets/red/book4/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/red/book4/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/red/book4/pages/page08.jpg"),
        sound: require("@data/assets/red/book4/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/red/book4/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/red/book4/pages/page10.jpg"),
        sound: require("@data/assets/red/book4/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/red/book4/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/red/book4/pages/page12.jpg"),
        sound: require("@data/assets/red/book4/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/red/book4/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/red/book4/pages/page14.jpg"),
        sound: require("@data/assets/red/book4/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/red/book4/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/red/book4/pages/page16.jpg"),
        sound: require("@data/assets/red/book4/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/red/book4/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/red/book4/pages/page18.jpg"),
        sound: require("@data/assets/red/book4/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/red/book4/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/red/book4/pages/page20.jpg"),
        sound: require("@data/assets/red/book4/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/red/book4/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/red/book4/pages/page22.jpg"),
        sound: require("@data/assets/red/book4/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/red/book4/pages/page23.jpg"),
        sound: require("@data/assets/red/book4/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/red/book4/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/red/book4/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/red/book4/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/red/book4/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/red/book4/thumbnail/front.jpg"),
      require("@data/assets/red/book4/thumbnail/page02.jpg"),
      require("@data/assets/red/book4/thumbnail/page03.jpg"),
      require("@data/assets/red/book4/thumbnail/page04.jpg"),
      require("@data/assets/red/book4/thumbnail/page05.jpg"),
      require("@data/assets/red/book4/thumbnail/page06.jpg"),
      require("@data/assets/red/book4/thumbnail/page07.jpg"),
      require("@data/assets/red/book4/thumbnail/page08.jpg"),
      require("@data/assets/red/book4/thumbnail/page09.jpg"),
      require("@data/assets/red/book4/thumbnail/page10.jpg"),
      require("@data/assets/red/book4/thumbnail/page11.jpg"),
      require("@data/assets/red/book4/thumbnail/page12.jpg"),
      require("@data/assets/red/book4/thumbnail/page13.jpg"),
      require("@data/assets/red/book4/thumbnail/page14.jpg"),
      require("@data/assets/red/book4/thumbnail/page15.jpg"),
      require("@data/assets/red/book4/thumbnail/page16.jpg"),
      require("@data/assets/red/book4/thumbnail/page17.jpg"),
      require("@data/assets/red/book4/thumbnail/page18.jpg"),
      require("@data/assets/red/book4/thumbnail/page19.jpg"),
      require("@data/assets/red/book4/thumbnail/page20.jpg"),
      require("@data/assets/red/book4/thumbnail/page21.jpg"),
      require("@data/assets/red/book4/thumbnail/page22.jpg"),
      require("@data/assets/red/book4/thumbnail/page23.jpg"),
      require("@data/assets/red/book4/thumbnail/page24.jpg"),
      require("@data/assets/red/book4/thumbnail/page25.jpg"),
      require("@data/assets/red/book4/thumbnail/page26.jpg"),
      require("@data/assets/red/book4/thumbnail/page27.jpg"),
    ],
  },
  //5
  {
    key: "c1-05",
    title: "우당탕 가족",
    grade: "5권",
    cover: require("@data/assets/red/book5/images/cover.jpg"),
    background: require("@data/assets/red/book5/pages/page05.jpg"),
    song: {
      url: require("@data/assets/red/book5/sounds/page23.mp3"),
      title: "꿀꺽꿀꺽 무엇을 마실까",
      caption: [
        "꿀꺽꿀꺽 무엇을 마실까 꿀꺽꿀꺽 무엇을 마실까 ",
        "마셔요 마셔요 hē hē 마셔요 마셔요 hē hē",
        "달콤한 주스 guǒzhī 새콤한 주스 guǒzhī",
        "나는 주스를 마셔요 wǒ hē guǒzhī",
        "마셔요 마셔요 hē hē 마셔요 마셔요 hē hē",
        "시원한 콜라 kělè 톡쏘는 콜라 kělè",
        "나는 콜라를 마셔요 wǒ hē kělè",
        "마셔요 마셔요 hē hē 마셔요 마셔요 hē hē",
        "향긋한 홍차 hóngchá 따뜻한 홍차 hóngchá",
        "나는 홍차를 마셔요 wǒ hē hóngchá",
        "꿀꺽꿀꺽 음료수를 마셔요 꿀꺽꿀꺽 음료수를 마셔요",
      ],
    },
    mov: {
      cn: "c2527fae68172222975b654300f6eabd_05",
      en: "919d3c1465466f74aa014dad101098c8_05",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/red/book5/images/img_R5-01.png"),
          sound: require("@data/assets/red/book5/sounds/KA05_W_01_과일_주스.mp3"),
          word: "果汁|guǒzhī",
        },
        {
          img: require("@data/assets/red/book5/images/img_R5-02.png"),
          sound: require("@data/assets/red/book5/sounds/KA05_W_02_콜라.mp3"),
          word: "可乐|kělè",
        },
        {
          img: require("@data/assets/red/book5/images/img_R5-03.png"),
          sound: require("@data/assets/red/book5/sounds/KA05_W_03_홍차.mp3"),
          word: "红茶|hóngchá",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/red/book5/images/img_R5-01.png"),
        sound: require("@data/assets/red/book5/sounds/KA05_W_01_과일_주스.mp3"),
        buttons: [{ ch2: "guǒzhī" }, { ch: "果汁" }, { ko: "과일 주스" }],
      },
      {
        img: require("@data/assets/red/book5/images/img_R5-02.png"),
        sound: require("@data/assets/red/book5/sounds/KA05_W_02_콜라.mp3"),
        buttons: [{ ch2: "kělè" }, { ch: "可乐" }, { ko: "콜라" }],
      },
      {
        img: require("@data/assets/red/book5/images/img_R5-03.png"),
        sound: require("@data/assets/red/book5/sounds/KA05_W_03_홍차.mp3"),
        buttons: [{ ch2: "hóngchá" }, { ch: "红茶" }, { ko: "홍차" }],
      },
    ],
    //5
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/red/book5/sounds/KA05_W_01_과일_주스.mp3"),
          img: require("@data/assets/red/book5/images/img_R5-02.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/red/book5/sounds/KA05_W_02_콜라.mp3"),
          answer: [
            [require("@data/assets/red/book5/images/img_R5-02.png"), true],
            [require("@data/assets/red/book5/images/img_R5-03.png"), false],
          ],
        },
        {
          type: "ty2",
          sound: require("@data/assets/red/book5/sounds/KA05_W_03_홍차.mp3"),
          answer: [
            [require("@data/assets/red/book5/images/img_R5-01.png"), false],
            [require("@data/assets/red/book5/images/img_R5-03.png"), true],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/red/book5/pages/front.jpg"),
        sound: require("@data/assets/red/book5/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/red/book5/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/red/book5/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/red/book5/pages/page04.jpg"),
        sound: require("@data/assets/red/book5/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/red/book5/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/red/book5/pages/page06.jpg"),
        sound: require("@data/assets/red/book5/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/red/book5/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/red/book5/pages/page08.jpg"),
        sound: require("@data/assets/red/book5/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/red/book5/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/red/book5/pages/page10.jpg"),
        sound: require("@data/assets/red/book5/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/red/book5/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/red/book5/pages/page12.jpg"),
        sound: require("@data/assets/red/book5/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/red/book5/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/red/book5/pages/page14.jpg"),
        sound: require("@data/assets/red/book5/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/red/book5/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/red/book5/pages/page16.jpg"),
        sound: require("@data/assets/red/book5/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/red/book5/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/red/book5/pages/page18.jpg"),
        sound: require("@data/assets/red/book5/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/red/book5/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/red/book5/pages/page20.jpg"),
        sound: require("@data/assets/red/book5/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/red/book5/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/red/book5/pages/page22.jpg"),
        sound: require("@data/assets/red/book5/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/red/book5/pages/page23.jpg"),
        sound: require("@data/assets/red/book5/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/red/book5/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/red/book5/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/red/book5/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/red/book5/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/red/book5/thumbnail/front.jpg"),
      require("@data/assets/red/book5/thumbnail/page02.jpg"),
      require("@data/assets/red/book5/thumbnail/page03.jpg"),
      require("@data/assets/red/book5/thumbnail/page04.jpg"),
      require("@data/assets/red/book5/thumbnail/page05.jpg"),
      require("@data/assets/red/book5/thumbnail/page06.jpg"),
      require("@data/assets/red/book5/thumbnail/page07.jpg"),
      require("@data/assets/red/book5/thumbnail/page08.jpg"),
      require("@data/assets/red/book5/thumbnail/page09.jpg"),
      require("@data/assets/red/book5/thumbnail/page10.jpg"),
      require("@data/assets/red/book5/thumbnail/page11.jpg"),
      require("@data/assets/red/book5/thumbnail/page12.jpg"),
      require("@data/assets/red/book5/thumbnail/page13.jpg"),
      require("@data/assets/red/book5/thumbnail/page14.jpg"),
      require("@data/assets/red/book5/thumbnail/page15.jpg"),
      require("@data/assets/red/book5/thumbnail/page16.jpg"),
      require("@data/assets/red/book5/thumbnail/page17.jpg"),
      require("@data/assets/red/book5/thumbnail/page18.jpg"),
      require("@data/assets/red/book5/thumbnail/page19.jpg"),
      require("@data/assets/red/book5/thumbnail/page20.jpg"),
      require("@data/assets/red/book5/thumbnail/page21.jpg"),
      require("@data/assets/red/book5/thumbnail/page22.jpg"),
      require("@data/assets/red/book5/thumbnail/page23.jpg"),
      require("@data/assets/red/book5/thumbnail/page24.jpg"),
      require("@data/assets/red/book5/thumbnail/page25.jpg"),
      require("@data/assets/red/book5/thumbnail/page26.jpg"),
      require("@data/assets/red/book5/thumbnail/page27.jpg"),
    ],
  },
  //6
  {
    key: "c1-06",
    title: "그림책이 좋아요",
    grade: "6권",
    cover: require("@data/assets/red/book6/images/cover.jpg"),
    background: require("@data/assets/red/book6/pages/page05.jpg"),
    song: {
      url: require("@data/assets/red/book6/sounds/page23.mp3"),
      title: "그림책 여행",
      caption: [
        "그림책 속 가득한 환상의 세계",
        "나는 그림책이 좋아요 xǐhuan 좋아요 xǐhuan",
        "고래 타고 슈웅 넓은 바다로 고래 고래 jīngyú jīngyú",
        "나는 고래가 좋아요 wǒ xǐhuan jīngyú wǒ xǐhuan jīngyú",
        "펭귄과 함께 슈웅 얼음 나라로 펭귄 펭귄 qǐ'é qǐ'é",
        "나는 펭귄이 좋아요  wǒ xǐhuan qǐ'é wǒ xǐhuan qǐ'é ",
        "판다와 함께 슈웅 대나무 숲으로 판다 판다  xióngmāo xióngmāo",
        "나는 판다가 좋아요 wǒ xǐhuan xióngmāo wǒ xǐhuan xióngmāo",
        "언제나 즐거운 그림책 여행 나는 그림책이 좋아요",
        "",
      ],
    },
    mov: {
      cn: "6e7c67b0456c913d112e6216d22c2dea_06",
      en: "0a4f95da4336a93ebc64354c38d3acd4_06",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/red/book6/images/img_R6-01.png"),
          sound: require("@data/assets/red/book6/sounds/KA06_W_01_고래.mp3"),
          word: "鲸鱼|jīngyú",
        },
        {
          img: require("@data/assets/red/book6/images/img_R6-02.png"),
          sound: require("@data/assets/red/book6/sounds/KA06_W_02_펭귄.mp3"),
          word: "企鹅|qǐ'é",
        },
        {
          img: require("@data/assets/red/book6/images/img_R6-03.png"),
          sound: require("@data/assets/red/book6/sounds/KA06_W_03_판다.mp3"),
          word: "熊猫|xióngmāo",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/red/book6/images/img_R6-01.png"),
        sound: require("@data/assets/red/book6/sounds/KA06_W_01_고래.mp3"),
        buttons: [{ ch2: "jīngyú" }, { ch: "鲸鱼" }, { ko: "고래" }],
      },
      {
        img: require("@data/assets/red/book6/images/img_R6-02.png"),
        sound: require("@data/assets/red/book6/sounds/KA06_W_02_펭귄.mp3"),
        buttons: [{ ch2: "qǐ'é" }, { ch: "企鹅" }, { ko: "펭귄" }],
      },
      {
        img: require("@data/assets/red/book6/images/img_R6-03.png"),
        sound: require("@data/assets/red/book6/sounds/KA06_W_03_판다.mp3"),
        buttons: [{ ch2: "xióngmāo" }, { ch: "熊猫" }, { ko: "판다" }],
      },
    ],
    //6
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/red/book6/sounds/KA06_W_01_고래.mp3"),
          img: require("@data/assets/red/book6/images/img_R6-01.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/red/book6/sounds/KA06_W_02_펭귄.mp3"),
          answer: [
            [require("@data/assets/red/book6/images/img_R6-02.png"), true],
            [require("@data/assets/red/book6/images/img_R6-03.png"), false],
          ],
        },
        {
          type: "ty2",
          sound: require("@data/assets/red/book6/sounds/KA06_W_03_판다.mp3"),
          answer: [
            [require("@data/assets/red/book6/images/img_R6-01.png"), false],
            [require("@data/assets/red/book6/images/img_R6-03.png"), true],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/red/book6/pages/front.jpg"),
        sound: require("@data/assets/red/book6/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/red/book6/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/red/book6/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/red/book6/pages/page04.jpg"),
        sound: require("@data/assets/red/book6/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/red/book6/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/red/book6/pages/page06.jpg"),
        sound: require("@data/assets/red/book6/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/red/book6/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/red/book6/pages/page08.jpg"),
        sound: require("@data/assets/red/book6/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/red/book6/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/red/book6/pages/page10.jpg"),
        sound: require("@data/assets/red/book6/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/red/book6/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/red/book6/pages/page12.jpg"),
        sound: require("@data/assets/red/book6/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/red/book6/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/red/book6/pages/page14.jpg"),
        sound: require("@data/assets/red/book6/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/red/book6/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/red/book6/pages/page16.jpg"),
        sound: require("@data/assets/red/book6/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/red/book6/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/red/book6/pages/page18.jpg"),
        sound: require("@data/assets/red/book6/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/red/book6/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/red/book6/pages/page20.jpg"),
        sound: require("@data/assets/red/book6/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/red/book6/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/red/book6/pages/page22.jpg"),
        sound: require("@data/assets/red/book6/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/red/book6/pages/page23.jpg"),
        sound: require("@data/assets/red/book6/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/red/book6/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/red/book6/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/red/book6/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/red/book6/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/red/book6/thumbnail/front.jpg"),
      require("@data/assets/red/book6/thumbnail/page02.jpg"),
      require("@data/assets/red/book6/thumbnail/page03.jpg"),
      require("@data/assets/red/book6/thumbnail/page04.jpg"),
      require("@data/assets/red/book6/thumbnail/page05.jpg"),
      require("@data/assets/red/book6/thumbnail/page06.jpg"),
      require("@data/assets/red/book6/thumbnail/page07.jpg"),
      require("@data/assets/red/book6/thumbnail/page08.jpg"),
      require("@data/assets/red/book6/thumbnail/page09.jpg"),
      require("@data/assets/red/book6/thumbnail/page10.jpg"),
      require("@data/assets/red/book6/thumbnail/page11.jpg"),
      require("@data/assets/red/book6/thumbnail/page12.jpg"),
      require("@data/assets/red/book6/thumbnail/page13.jpg"),
      require("@data/assets/red/book6/thumbnail/page14.jpg"),
      require("@data/assets/red/book6/thumbnail/page15.jpg"),
      require("@data/assets/red/book6/thumbnail/page16.jpg"),
      require("@data/assets/red/book6/thumbnail/page17.jpg"),
      require("@data/assets/red/book6/thumbnail/page18.jpg"),
      require("@data/assets/red/book6/thumbnail/page19.jpg"),
      require("@data/assets/red/book6/thumbnail/page20.jpg"),
      require("@data/assets/red/book6/thumbnail/page21.jpg"),
      require("@data/assets/red/book6/thumbnail/page22.jpg"),
      require("@data/assets/red/book6/thumbnail/page23.jpg"),
      require("@data/assets/red/book6/thumbnail/page24.jpg"),
      require("@data/assets/red/book6/thumbnail/page25.jpg"),
      require("@data/assets/red/book6/thumbnail/page26.jpg"),
      require("@data/assets/red/book6/thumbnail/page27.jpg"),
    ],
  },
  //7
  {
    key: "c1-07",
    title: "제멋대로 공주님",
    grade: "7권",
    cover: require("@data/assets/red/book7/images/cover.jpg"),
    background: require("@data/assets/red/book7/pages/page05.jpg"),
    song: {
      url: require("@data/assets/red/book7/sounds/page23.mp3"),
      title: "맛있게 먹어요",
      caption: [
        "꼬르륵 꼬르륵 무엇을 먹을까 chī chī",
        "꼬르륵 꼬르륵 무엇을 먹을까  chī chī",
        "까만 윤기 자르르 짜장면 zhájiàngmiàn",
        "노릇노릇 잘구운 소시지 xiāngcháng",
        "나는 짜장면을 먹어요 wǒ chī zhájiàngmiàn",
        "나는 소시지를 먹어요 wǒ chī xiāngcháng",
        "냠냠냠 냠냠냠 무엇을 먹을까 chī chī",
        "냠냠냠 냠냠냠 무엇을 먹을까  chī chī ",
        "신선하고 상큼한 과일 shuǐguǒ",
        "따끈따끈 맛있는 핫도그 règǒu",
        "나는 과일을 먹어요 wǒ chī shuǐguǒ",
        "나는 핫도그를 먹어요 wǒ chī règǒu",
        "맛있게 먹어요 chī chī chī",
      ],
    },
    mov: {
      cn: "6d6fbae32e476142e13731e46918aaf8_07",
      en: "31b1b99a39603e0d40455fdb2a0b7d1f_07",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/red/book7/images/img_R7-01.png"),
          sound: require("@data/assets/red/book7/sounds/KA07_W_01_짜장면.mp3"),
          word: "炸酱面|zhájiàngmiàn",
        },
        {
          img: require("@data/assets/red/book7/images/img_R7-02.png"),
          sound: require("@data/assets/red/book7/sounds/KA07_W_02_소시지.mp3"),
          word: "香肠|xiāngcháng",
        },
        {
          img: require("@data/assets/red/book7/images/img_R7-03.png"),
          sound: require("@data/assets/red/book7/sounds/KA07_W_03_과일.mp3"),
          word: "水果|shuǐguǒ",
        },
        {
          img: require("@data/assets/red/book7/images/img_R7-04.png"),
          sound: require("@data/assets/red/book7/sounds/KA07_W_04_핫도그.mp3"),
          word: "热狗|règǒu",
        },
      ],
    },

    word: [
      {
        img: require("@data/assets/red/book7/images/img_R7-01.png"),
        sound: require("@data/assets/red/book7/sounds/KA07_W_01_짜장면.mp3"),
        buttons: [{ ch2: "zhájiàngmiàn" }, { ch: "炸酱面" }, { ko: "짜장면" }],
      },
      {
        img: require("@data/assets/red/book7/images/img_R7-02.png"),
        sound: require("@data/assets/red/book7/sounds/KA07_W_02_소시지.mp3"),
        buttons: [{ ch2: "xiāngcháng" }, { ch: "香肠" }, { ko: "소시지" }],
      },
      {
        img: require("@data/assets/red/book7/images/img_R7-03.png"),
        sound: require("@data/assets/red/book7/sounds/KA07_W_03_과일.mp3"),
        buttons: [{ ch2: "shuǐguǒ" }, { ch: "水果" }, { ko: "과일" }],
      },
      {
        img: require("@data/assets/red/book7/images/img_R7-04.png"),
        sound: require("@data/assets/red/book7/sounds/KA07_W_04_핫도그.mp3"),
        buttons: [{ ch2: "règǒu" }, { ch: "热狗" }, { ko: "핫도그" }],
      },
    ],
    //7
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/red/book7/sounds/KA07_W_01_짜장면.mp3"),
          img: require("@data/assets/red/book7/images/img_R7-04.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/red/book7/sounds/KA07_W_02_소시지.mp3"),
          answer: [
            [require("@data/assets/red/book7/images/img_R7-02.png"), true],
            [require("@data/assets/red/book7/images/img_R7-03.png"), false],
          ],
        },
        {
          type: "ty2",
          sound: require("@data/assets/red/book7/sounds/KA07_W_04_핫도그.mp3"),
          answer: [
            [require("@data/assets/red/book7/images/img_R7-04.png"), true],
            [require("@data/assets/red/book7/images/img_R7-01.png"), false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/red/book7/pages/front.jpg"),
        sound: require("@data/assets/red/book7/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/red/book7/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/red/book7/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/red/book7/pages/page04.jpg"),
        sound: require("@data/assets/red/book7/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/red/book7/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/red/book7/pages/page06.jpg"),
        sound: require("@data/assets/red/book7/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/red/book7/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/red/book7/pages/page08.jpg"),
        sound: require("@data/assets/red/book7/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/red/book7/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/red/book7/pages/page10.jpg"),
        sound: require("@data/assets/red/book7/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/red/book7/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/red/book7/pages/page12.jpg"),
        sound: require("@data/assets/red/book7/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/red/book7/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/red/book7/pages/page14.jpg"),
        sound: require("@data/assets/red/book7/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/red/book7/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/red/book7/pages/page16.jpg"),
        sound: require("@data/assets/red/book7/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/red/book7/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/red/book7/pages/page18.jpg"),
        sound: require("@data/assets/red/book7/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/red/book7/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/red/book7/pages/page20.jpg"),
        sound: require("@data/assets/red/book7/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/red/book7/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/red/book7/pages/page22.jpg"),
        sound: require("@data/assets/red/book7/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/red/book7/pages/page23.jpg"),
        sound: require("@data/assets/red/book7/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/red/book7/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/red/book7/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/red/book7/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/red/book7/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/red/book7/thumbnail/front.jpg"),
      require("@data/assets/red/book7/thumbnail/page02.jpg"),
      require("@data/assets/red/book7/thumbnail/page03.jpg"),
      require("@data/assets/red/book7/thumbnail/page04.jpg"),
      require("@data/assets/red/book7/thumbnail/page05.jpg"),
      require("@data/assets/red/book7/thumbnail/page06.jpg"),
      require("@data/assets/red/book7/thumbnail/page07.jpg"),
      require("@data/assets/red/book7/thumbnail/page08.jpg"),
      require("@data/assets/red/book7/thumbnail/page09.jpg"),
      require("@data/assets/red/book7/thumbnail/page10.jpg"),
      require("@data/assets/red/book7/thumbnail/page11.jpg"),
      require("@data/assets/red/book7/thumbnail/page12.jpg"),
      require("@data/assets/red/book7/thumbnail/page13.jpg"),
      require("@data/assets/red/book7/thumbnail/page14.jpg"),
      require("@data/assets/red/book7/thumbnail/page15.jpg"),
      require("@data/assets/red/book7/thumbnail/page16.jpg"),
      require("@data/assets/red/book7/thumbnail/page17.jpg"),
      require("@data/assets/red/book7/thumbnail/page18.jpg"),
      require("@data/assets/red/book7/thumbnail/page19.jpg"),
      require("@data/assets/red/book7/thumbnail/page20.jpg"),
      require("@data/assets/red/book7/thumbnail/page21.jpg"),
      require("@data/assets/red/book7/thumbnail/page22.jpg"),
      require("@data/assets/red/book7/thumbnail/page23.jpg"),
      require("@data/assets/red/book7/thumbnail/page24.jpg"),
      require("@data/assets/red/book7/thumbnail/page25.jpg"),
      require("@data/assets/red/book7/thumbnail/page26.jpg"),
      require("@data/assets/red/book7/thumbnail/page27.jpg"),
    ],
  },
  //8
  {
    key: "c1-08",
    title: "쉿! 비밀이에요",
    grade: "8권",
    cover: require("@data/assets/red/book8/images/cover.jpg"),
    background: require("@data/assets/red/book8/pages/page05.jpg"),
    song: {
      url: require("@data/assets/red/book8/sounds/page23.mp3"),
      title: "우리는 최고의 요리사",
      caption: [
        "우리는 요리사 최고의 요리사",
        "맛있게 요리를 해요 zuò cài zuò cài",
        "나는야 원숭이 hóuzi hóuzi",
        "원숭이가 요리를 해요 hóuzi zuò cài",
        "나는야 고슴도치 cìwei cìwei",
        "고슴도치가 요리를 해요 cìwei zuò cài",
        "나는야 다람쥐 sōngshǔ sōngshǔ",
        "다람쥐가 요리를 해요 sōngshǔ zuò cài",
        "요리를 해요 zuò cài zuò cài",
        "즐겁게 요리를 해요  zuò cài zuò cài",
      ],
    },
    mov: {
      cn: "18abe6d6e07ee206767a96f8a5926499_08",
      en: "f9409d7997b6c3bdbcddbd672f1b145f_08",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/red/book8/images/img_R8-01.png"),
          sound: require("@data/assets/red/book8/sounds/KA08_W_01_원숭이.mp3"),
          word: "猴子|hóuzi",
        },
        {
          img: require("@data/assets/red/book8/images/img_R8-02.png"),
          sound: require("@data/assets/red/book8/sounds/KA08_W_02_고슴도치.mp3"),
          word: "刺猬|cìwei",
        },
        {
          img: require("@data/assets/red/book8/images/img_R8-03.png"),
          sound: require("@data/assets/red/book8/sounds/KA08_W_03_다람쥐.mp3"),
          word: "松鼠|sōngshǔ",
        },
      ],
    },

    word: [
      {
        img: require("@data/assets/red/book8/images/img_R8-01.png"),
        sound: require("@data/assets/red/book8/sounds/KA08_W_01_원숭이.mp3"),
        buttons: [{ ch2: "hóuzi" }, { ch: "猴子" }, { ko: "원숭이" }],
      },
      {
        img: require("@data/assets/red/book8/images/img_R8-02.png"),
        sound: require("@data/assets/red/book8/sounds/KA08_W_02_고슴도치.mp3"),
        buttons: [{ ch2: "cìwei" }, { ch: "刺猬" }, { ko: "고슴도치" }],
      },
      {
        img: require("@data/assets/red/book8/images/img_R8-03.png"),
        sound: require("@data/assets/red/book8/sounds/KA08_W_03_다람쥐.mp3"),
        buttons: [{ ch2: "sōngshǔ" }, { ch: "松鼠" }, { ko: "다람쥐" }],
      },
    ],
    //8
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/red/book8/sounds/KA08_W_01_원숭이.mp3"),
          img: require("@data/assets/red/book8/images/img_R8-01.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/red/book8/sounds/KA08_W_02_고슴도치.mp3"),
          answer: [
            [require("@data/assets/red/book8/images/img_R8-01.png"), false],
            [require("@data/assets/red/book8/images/img_R8-02.png"), true],
          ],
        },
        {
          type: "ty2",
          sound: require("@data/assets/red/book8/sounds/KA08_W_03_다람쥐.mp3"),
          answer: [
            [require("@data/assets/red/book8/images/img_R8-03.png"), true],
            [require("@data/assets/red/book8/images/img_R8-01.png"), false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/red/book8/pages/front.jpg"),
        sound: require("@data/assets/red/book8/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/red/book8/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/red/book8/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/red/book8/pages/page04.jpg"),
        sound: require("@data/assets/red/book8/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/red/book8/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/red/book8/pages/page06.jpg"),
        sound: require("@data/assets/red/book8/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/red/book8/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/red/book8/pages/page08.jpg"),
        sound: require("@data/assets/red/book8/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/red/book8/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/red/book8/pages/page10.jpg"),
        sound: require("@data/assets/red/book8/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/red/book8/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/red/book8/pages/page12.jpg"),
        sound: require("@data/assets/red/book8/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/red/book8/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/red/book8/pages/page14.jpg"),
        sound: require("@data/assets/red/book8/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/red/book8/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/red/book8/pages/page16.jpg"),
        sound: require("@data/assets/red/book8/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/red/book8/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/red/book8/pages/page18.jpg"),
        sound: require("@data/assets/red/book8/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/red/book8/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/red/book8/pages/page20.jpg"),
        sound: require("@data/assets/red/book8/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/red/book8/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/red/book8/pages/page22.jpg"),
        sound: require("@data/assets/red/book8/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/red/book8/pages/page23.jpg"),
        sound: require("@data/assets/red/book8/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/red/book8/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/red/book8/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/red/book8/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/red/book8/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/red/book8/thumbnail/front.jpg"),
      require("@data/assets/red/book8/thumbnail/page02.jpg"),
      require("@data/assets/red/book8/thumbnail/page03.jpg"),
      require("@data/assets/red/book8/thumbnail/page04.jpg"),
      require("@data/assets/red/book8/thumbnail/page05.jpg"),
      require("@data/assets/red/book8/thumbnail/page06.jpg"),
      require("@data/assets/red/book8/thumbnail/page07.jpg"),
      require("@data/assets/red/book8/thumbnail/page08.jpg"),
      require("@data/assets/red/book8/thumbnail/page09.jpg"),
      require("@data/assets/red/book8/thumbnail/page10.jpg"),
      require("@data/assets/red/book8/thumbnail/page11.jpg"),
      require("@data/assets/red/book8/thumbnail/page12.jpg"),
      require("@data/assets/red/book8/thumbnail/page13.jpg"),
      require("@data/assets/red/book8/thumbnail/page14.jpg"),
      require("@data/assets/red/book8/thumbnail/page15.jpg"),
      require("@data/assets/red/book8/thumbnail/page16.jpg"),
      require("@data/assets/red/book8/thumbnail/page17.jpg"),
      require("@data/assets/red/book8/thumbnail/page18.jpg"),
      require("@data/assets/red/book8/thumbnail/page19.jpg"),
      require("@data/assets/red/book8/thumbnail/page20.jpg"),
      require("@data/assets/red/book8/thumbnail/page21.jpg"),
      require("@data/assets/red/book8/thumbnail/page22.jpg"),
      require("@data/assets/red/book8/thumbnail/page23.jpg"),
      require("@data/assets/red/book8/thumbnail/page24.jpg"),
      require("@data/assets/red/book8/thumbnail/page25.jpg"),
      require("@data/assets/red/book8/thumbnail/page26.jpg"),
      require("@data/assets/red/book8/thumbnail/page27.jpg"),
    ],
  },
];
